import { IItemsStyle } from "./IItemsStyle";

export interface IItemsStyleSpecifiable {
  itemsStyle: IItemsStyle;
}

export function instanceOfIItemsStyleSpecifiable(instance: any): instance is IItemsStyleSpecifiable {
  return instance
    && (instance.itemsStyle !== undefined);
}
